import { Toaster } from 'react-hot-toast'
import { ToastItem } from './ToastItem'

export function Theme({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Toaster
        toastOptions={{
          duration: 20000, // 20 seconds, minimum for accessibility (Allyant)
        }}
        data-testid="toaster"
        containerClassName="!inset-0 max-h-[100vh] bottom-0 overflow-auto flex flex-col pointer-events-none"
        gutter={0}
        position="bottom-center"
      >
        {(t) => <ToastItem t={t} />}
      </Toaster>
      {children}
    </>
  )
}
